import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDialog } from 'components/Dialog';
import { Heading, LoadingIndicator, Text } from 'roo-ui/components';

const ProgressDialog = ({ isSubmitting }) => {
  const { Dialog, openDialog, closeDialog } = useDialog();
  useEffect(() => {
    isSubmitting ? openDialog() : closeDialog();
  }, [isSubmitting, closeDialog, openDialog]);

  return (
    <Dialog>
      <Heading.h3 textAlign="center" mb={6}>
        We&apos;re sending your message
      </Heading.h3>
      <Text display="block" textAlign="center" mb={6}>
        Please wait while we send your message to our customer service team.
      </Text>
      <LoadingIndicator />
    </Dialog>
  );
};

ProgressDialog.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
};

export default ProgressDialog;
